import React from 'react';
import Image from 'next/image';

type Props = {
  urlLink: string | null;
};

const MediaBackground = ({ urlLink }: Props) => {
  if (!urlLink) return null;

  // Check if the URL is an image or video based on file extension
  const isVideo = /\.(mp4|webm|ogg|mov)$/i.test(urlLink);
  const isImage = /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(urlLink);

  const commonStyle = {
    minWidth: '100%',
    minHeight: '100%',
    objectFit: 'cover' as const,
    width: '100%',
    height: '100%',
    top: '50%',
    left: 0,
    right: 0,
    transform: 'translateY(-50%)',
    position: 'absolute' as const,
  };

  if (isVideo) {
    return (
      <video playsInline autoPlay loop muted id="background-media" style={commonStyle}>
        <source src={urlLink} type="video/mp4" />
      </video>
    );
  }

  if (isImage) {
    return (
      <div style={{ ...commonStyle, position: 'relative', overflow: 'hidden' }}>
        <Image src={urlLink} alt="Background" fill style={{ objectFit: 'cover' }} priority />
      </div>
    );
  }

  // Fallback: try to render as image if extension not recognized
  return (
    <div style={{ ...commonStyle, position: 'relative', overflow: 'hidden' }}>
      <Image src={urlLink} alt="Background" fill style={{ objectFit: 'cover' }} priority />
    </div>
  );
};

export default MediaBackground;
